module.exports = __webpack_public_path__ + "img/battery-full.dbfcf10b.svg";